import React from 'react'
import 'video.js/dist/video-js.css'

type VideoPlayerProps = React.ComponentProps<'div'> & {
  videoProps?: React.ComponentProps<'video'>
  height?: number
}

export const VideoPlayer = React.forwardRef<HTMLVideoElement, VideoPlayerProps>(
  ({ videoProps, height, ...props }, ref) => {
    return (
      <div {...props} data-vjs-player>
        <video
          {...videoProps}
          ref={ref}
          className={`video-js w-full ${videoProps?.className}`}
          playsInline
          height={height}
        />
      </div>
    )
  }
)
